<!-- 为同事预登记 编辑页面 -->
<template>
  <div class="menu-item-r">
    <div class="bl-register-box vv-register" v-loading="loading" :element-loading-text="$t('Please wait')">
      <el-form size="small" :model="inputVal" :rules="rules" class="v-from-wrap" ref="emailInfo">
        <div class="reg-title margin-t-0">
            {{ $t("login2s.fillInformation") }}
            <!-- <div class="margin-t-24" v-if="!id">
                <el-checkbox v-model="checked">{{ $t("login2s.bringInInformation") }}</el-checkbox>
            </div> -->
        </div>
        <!-- 个人信息 -->
        <div class="reg-title" v-if="fieldsLength[0] > 0">{{ $t('login2s.personInfo') }}</div>
        <el-row :gutter="30">
          <template v-for="item in configInputList">
            <el-col :span="24" :key="item.id" v-if="personFieldsList.indexOf(item.keyword) > -1">
              <!-- 上传图片 -->
              <template v-if="uploadFields.indexOf(item.keyword) > -1">
                <!-- 头像 -->
                <el-form-item label-width="0" :prop="item.keyword"  v-if="item.keyword == 'headImage'">
                  <div class="flex-start headerImg m-b-24">
                    <h4>
                      <template v-if="item.required">
                        <span class="v-xing">* </span>
                      </template>{{ getLabelName(item) }}
                    </h4>
                    <div>
                      <p>{{$t('Head Image1')}}<br/>{{$t('Head Image2')}}</p>
                    </div>
                  </div>
                  <div class="v-header div v-headerImg v-register-flex" style="align-items:flex-start">
                    <div class="v-load-img-box align-center padding-left-104 v-headerImg-r" style="margin-top: 0; margin-bottom: 0;">
                      <div class="relative v-header-relative" v-loading="imgLoading" :class="{ 'v-uploader-disabled': !item.editable }">
                        <el-upload
                          class="v-uploader"
                          action=""
                          :disabled="!item.editable"
                          :show-file-list="false"
                          :http-request="loadImg"
                          :accept="uploadType">
                            <img v-if="inputVal.headImage" :src="inputVal.headImage" alt="" class="v-header-img" />
                            <i v-else class="iconfont iconshangchuan"></i>
                        </el-upload>
                      </div>
                      <div class="font-size-14 text-right">
                        <div class="flex-end align-center v-btn-box" v-if="item.editable">
                          <!-- <el-upload action="" 
                            :http-request="loadImg" :show-file-list="false" :accept="uploadType">
                            <span class="theme-color">{{ inputVal.headImage ? $t('Upload again') : $t('Upload picture') }}</span>
                          </el-upload> -->
                          <span class="theme-color pointer padding-l-12" @click="inputVal.headImage = ''" v-if="inputVal.headImage">{{ $t('del') }}</span>
                        </div>
                      </div>
                      <span class="v-up-tip v-head-up-tip tipsColor margin-tb-12"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                    </div>

                    <div class="v-headerImg-l" style="height: 191px">
                      <template v-if="language == 'zh'">
                        <img :src="headerImgCn"/>
                      </template>
                      <template v-else>
                        <img :src="headerImgEn"/>
                      </template>
                    </div>
                  </div>
                  <el-input v-model="inputVal.headImage" v-show="false"></el-input>
                </el-form-item>
                <!-- 个人工作证 -->
                <el-form-item class="v-img-border" label-width="0" :prop="item.keyword"  v-if="item.keyword == 'workPass' || item.keyword == 'idImage'">
                  <div class="flex-start headerImg m-b-24">
                    <h4>
                      <template v-if="item.required">
                        <span class="v-xing">* </span>
                      </template>{{ getLabelName(item) }}
                    </h4>
                    <div v-if="!(item.keyword == 'idImage' && language === 'en')">
                      <p>{{$t('workPassTips')}}</p> 
                    </div>
                  </div>
                  <div class="v-header div v-headerImg v-register-flex" style="align-items:flex-start">
                    <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                      <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingWorkPass" :class="{ 'v-uploader-disabled': !item.editable }">
                        <el-upload
                          class="v-uploader"
                          action=""
                          :disabled="!item.editable"
                          :show-file-list="false"
                          :http-request="(req) => {loadWorkPassImg(req, item.keyword)}"
                          :accept="uploadType">
                          <img v-if="inputVal[item.keyword]" :src="inputVal[item.keyword]" alt="" class="v-header-img" />
                          <i v-else class="iconfont iconshangchuan"></i>
                        </el-upload>
                      </div>
                      <div class="font-size-14 text-right">
                        <div class="flex-end align-center v-btn-box" v-if="item.editable">
                          <div class="flex-start align-center v-btn-box" v-if="item.editable">
                            <!-- <el-upload action="" :http-request="(req) => {loadWorkPassImg(req, item.keyword)}" :show-file-list="false" :accept="uploadType">
                              <span class="theme-color padding-r-12">
                                {{inputVal[item.keyword] ? $t('Upload again') : $t('Upload picture')}}</span>
                            </el-upload> -->
                            <span
                              class="theme-color pointer"
                              @click="inputVal[item.keyword] = ''"
                              v-if="inputVal[item.keyword]">{{ $t('del') }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="v-up-tip v-head-up-tip tipsColor margin-tb-12"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                    </div>

                    <div class="v-workPass-l" style="height: 191px">
                      <template v-if="language == 'zh'">
                        <img :src="workPassCn"/>
                      </template>
                      <template v-else>
                        <img :src="workPassEn"/>
                      </template>
                    </div>
                  </div>
                  <el-input v-model="inputVal[item.keyword]" v-show="false"></el-input>
                </el-form-item>
                <!-- 登记证 -->
                <el-form-item class="v-img-border" label-width="0" :prop="item.keyword" v-if="item.keyword == 'registration'">
                  <div class="flex-start headerImg m-b-24">
                    <h4>
                      <template v-if="item.required">
                        <span class="v-xing">* </span>
                      </template>{{ getLabelName(item) }}
                    </h4>
                    <div>
                      <p>{{$t('registrationTips')}}</p>
                    </div>
                  </div>
                  <div class="v-header div v-headerImg v-register-flex" style="align-items:flex-start">
                    <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                      <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingRegistration" :class="{ 'v-uploader-disabled': !item.editable }">
                        <el-upload
                          class="v-uploader"
                          action=""
                          :disabled="!item.editable"
                          :show-file-list="false"
                          :http-request="loadRegistrationImg"
                          :accept="uploadType">
                            <img v-if="inputVal.registration" :src="inputVal.registration" alt="" class="v-header-img" />
                            <i v-else class="iconfont iconshangchuan"></i>
                        </el-upload>
                      </div>
                      <div class="font-size-14 text-right">
                        <div class="flex-end align-center v-btn-box" v-if="item.editable">
                          <div class="flex-start align-center v-btn-box" v-if="item.editable">
                            <!-- <el-upload action="" :http-request="loadRegistrationImg" :show-file-list="false" :accept="uploadType">
                              <span class="theme-color padding-r-12">
                                {{inputVal.registration ? $t('Upload again') : $t('Upload picture')}}</span>
                            </el-upload> -->
                            <span
                              class="theme-color pointer"
                              @click="inputVal.registration = ''"
                              v-if="inputVal.registration">{{ $t('del') }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="v-up-tip v-head-up-tip tipsColor margin-tb-12"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                    </div>
                    <div class="v-workPass-l" style="height: 191px;">
                      <template v-if="language == 'zh'">
                        <img :src="registrationCn"/>
                      </template>
                      <template v-else>
                        <img :src="registrationEn"/>
                      </template>
                    </div>
                  </div>
                  <el-input v-model="inputVal.registration" v-show="false"></el-input>
                </el-form-item>
              </template>
              <template v-else>
                <template v-if="item.keyword == 'cityId' || item.keyword == 'provinceId'">
                  <el-form-item :label="getLabelName(item)" :prop="item.keyword" v-if="codeDisabled()">
                    <!-- 省份 -->
                    <el-select
                      :placeholder="getLabelName(item, 'placeholder')"
                      v-model="inputVal.provinceId"
                      v-loading="pLoading"
                      @change="changeProvince"
                      :disabled="!item.editable"
                      v-if="item.keyword == 'provinceId'"
                      filterable>
                      <el-option 
                        v-for="c in pOption"
                        :key="c.id" 
                        :value="parseInt(c.id)" 
                        :label="getLabelName(c, 'address')"></el-option>
                    </el-select>
                    <!-- 城市 -->
                    <el-select
                        :placeholder="getLabelName(item, 'placeholder')"
                        v-model="inputVal.cityId"
                        v-loading="cityLoading"
                        @change="changeCity" 
                        :disabled="!item.editable" 
                        v-if="item.keyword == 'cityId'" filterable>
                            <el-option 
                                v-for="c in cOption" 
                                :key="c.id" 
                                :value="parseInt(c.id)" 
                                :label="getLabelName(c, 'address')"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item :label="getLabelName(item)" :prop="item.keyword">
                    <template v-if="!item.canSelect && item.keyword !== 'validateCode'">
                        <template v-if="$config.form.allowSpaceFields.indexOf(item.keyword) > -1">
                            <el-input
                                :placeholder="getLabelName(item, 'placeholder')"
                                v-model="inputVal[item.keyword]"
                                :disabled="!item.editable"
                                :maxlength="item.inputLength || 200">
                                <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode">{{inputVal.faxCode}}</template>
                                <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode1"> - </template>
                                <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode1">{inputVal.faxCode1}}</template>
                            </el-input>
                        </template>
                        <template v-else>
                            <el-input
                                :placeholder="getLabelName(item, 'placeholder')"
                                v-model.trim="inputVal[item.keyword]"
                                :disabled="!item.editable"
                                :maxlength="item.inputLength || 200">
                                <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode">{{inputVal.faxCode}}</template>
                                <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode1"> - </template>
                                <template slot="prepend" v-if="$config.form.cityPhoneCodeFields.indexOf(item.keyword) > -1 && inputVal.faxCode1">{inputVal.faxCode1}}</template>
                            </el-input>
                        </template>
                    </template>
                    <template v-else>
                      <!-- 国家 -->
                      <el-select
                        :placeholder="getLabelName(item, 'placeholder')"
                        v-loading="cLoading"
                        v-model="inputVal.countryId"
                        @change="changeCountryCallback"
                        :disabled="!item.editable"
                        v-if="item.keyword == 'countryId'"
                        filterable>
                            <el-option 
                                v-for="c in gOption" 
                                :key="c.id" 
                                :value="parseInt(c.id)" 
                                :label="getLabelName(c, 'address')"></el-option>
                      </el-select>

                      <!-- 性别 -->
                      <el-select
                        :placeholder="getLabelName(item, 'placeholder')"
                        :disabled="!item.editable"
                        v-model="inputVal[item.keyword]"
                        v-if="fieldsList.indexOf(item.keyword) == -1 && item.keyword == 'gender'">
                            <el-option v-for="c in sexOption" :key="c.value" :value="c.value" :label="c.label"></el-option>
                      </el-select>
                      <!-- 社交媒体 -->
                      <el-select :placeholder="getLabelName(item, 'placeholder')" v-model="inputVal[item.keyword]" :disabled="!item.editable" v-if="item.keyword == 'socialMedia'" filterable>
                        <el-option v-for="c in socialMediaOption" :key="c.value" :value="c.value" :label="c.label"></el-option>
                      </el-select>
                      <!-- 证件类型 -->
                      <el-select :placeholder="getLabelName(item, 'placeholder')" v-model="inputVal[item.keyword]" :disabled="!item.editable" v-if="item.keyword == 'idType'" filterable>
                        <el-option v-for="c in idTypeOption" :key="c.value" :value="c.value" :label="c.label"></el-option>
                      </el-select>
                    </template>
                  </el-form-item>
                </template>
              </template>
            </el-col>
          </template>
        </el-row>
        <!-- 公司信息 -->
        <div class="reg-title" v-if="fieldsLength[1] > 0">{{ $t('login2s.companyInfo') }}</div>
        <div class="m-b-12" style="margin-top: -12px;" v-if="!id">
            <el-checkbox v-model="checked">{{ $t("login2s.bringInInformation") }}</el-checkbox>
        </div>
        <el-row :gutter="30">
          <template v-for="item in configInputList">
            <el-col :span="24" :key="item.id" v-if="companyFieldsList.indexOf(item.keyword) > -1">
              <!-- 头像 -->
              <template v-if="uploadFields.indexOf(item.keyword) > -1">
                <!-- 登记证 -->
                <el-form-item class="v-img-border" label-width="0" :prop="item.keyword" v-if="item.keyword == 'registration'">
                  <div class="flex-start headerImg m-b-24">
                    <h4>
                      <template v-if="item.required">
                        <span class="v-xing">* </span>
                      </template>{{ getLabelName(item) }}
                    </h4>
                    <div>
                      <p>{{$t('registrationTips')}}</p>
                    </div>
                  </div>
                  <div class="v-header div v-headerImg v-register-flex" style="align-items:flex-start">
                    <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                      <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingRegistration" :class="{ 'v-uploader-disabled': !item.editable }">
                        <el-upload
                          class="v-uploader"
                          action=""
                          :disabled="!item.editable"
                          :show-file-list="false"
                          :http-request="loadRegistrationImg"
                          :accept="uploadType">
                          <img v-if="inputVal.registration" :src="inputVal.registration" alt="" class="v-header-img" />
                          <i v-else class="iconfont iconshangchuan"></i>
                        </el-upload>
                      </div>
                      <div class="font-size-14 text-right">
                        <div class="flex-end align-center v-btn-box" v-if="item.editable">
                          <div class="flex-start align-center v-btn-box" v-if="item.editable">
                            <!-- <el-upload action="" :http-request="loadRegistrationImg" :show-file-list="false" :accept="uploadType">
                              <span class="theme-color padding-r-12">
                                {{inputVal.registration ? $t('Upload again') : $t('Upload picture')}}</span>
                            </el-upload> -->
                            <span
                              class="theme-color pointer"
                              @click="inputVal.registration = ''"
                              v-if="inputVal.registration">{{ $t('del') }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="v-up-tip v-head-up-tip tipsColor margin-tb-12"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                    </div>
                    <div class="v-workPass-l" style="height: 191px">
                      <template v-if="language == 'zh'">
                        <img :src="registrationCn"/>
                      </template>
                      <template v-else>
                        <img :src="registrationEn"/>
                      </template>
                    </div>
                  </div>
                  <el-input v-model="inputVal.registration" v-show="false"></el-input>
                </el-form-item>
                <!-- 证件照 -->
                <!-- 个人工作证 -->
                <el-form-item class="v-img-border" label-width="0" :prop="item.keyword"  v-if="item.keyword == 'workPass' || item.keyword == 'idImage'">
                  <div class="flex-start headerImg m-b-24">
                    <h4>
                      <template v-if="item.required">
                        <span class="v-xing">* </span>
                      </template>{{ getLabelName(item) }}
                    </h4>
                    <div>
                      <p>{{$t('workPassTips')}}</p>
                    </div>
                  </div>
                  <div class="v-header div v-headerImg v-register-flex" style="align-items:flex-start">
                    <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                      <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingWorkPass" :class="{ 'v-uploader-disabled': !item.editable }">
                        <el-upload
                          class="v-uploader"
                          action=""
                          :disabled="!item.editable"
                          :show-file-list="false"
                          :http-request="(req) => {loadWorkPassImg(req, item.keyword)}"
                          :accept="uploadType">
                          <img v-if="inputVal[item.keyword]" :src="inputVal[item.keyword]" alt="" class="v-header-img" />
                          <i v-else class="iconfont iconshangchuan"></i>
                        </el-upload>
                      </div>
                      <div class="font-size-14 text-right">
                        <div class="flex-end align-center v-btn-box" v-if="item.editable">
                          <div class="flex-start align-center v-btn-box" v-if="item.editable">
                            <!-- <el-upload action="" :http-request="(req) => {loadWorkPassImg(req, item.keyword)}" :show-file-list="false" :accept="uploadType">
                              <span class="theme-color padding-r-12">
                                  {{inputVal[item.keyword] ? $t('Upload again') : $t('Upload picture')}}</span>
                            </el-upload> -->
                            <span
                              class="theme-color pointer"
                              @click="inputVal[item.keyword] = ''"
                              v-if="inputVal[item.keyword]">{{ $t('del') }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="v-up-tip v-head-up-tip tipsColor margin-tb-12"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                    </div>

                    <div class="v-workPass-l" style="height: 191px">
                      <template v-if="language == 'zh'">
                        <img :src="workPassCn"/>
                      </template>
                      <template v-else>
                        <img :src="workPassCn"/>
                      </template>
                    </div>
                  </div>
                  <el-input v-model="inputVal[item.keyword]" v-show="false"></el-input>
                </el-form-item>
              </template>
              <el-form-item v-else :label="getLabelName(item)" :prop="item.keyword">
                <template v-if="$config.form.allowSpaceFields.indexOf(item.keyword) > -1">
                    <el-input
                    :placeholder="getLabelName(item, 'placeholder')"
                    v-model="inputVal[item.keyword]"
                    :disabled="!item.editable"
                    v-if="!item.canSelect"
                    :class="{ 'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1 }"
                    :maxlength="item.inputLength || 200">
                    </el-input>
                </template>
                <template v-else>
                    <el-input
                    :placeholder="getLabelName(item, 'placeholder')"
                    v-model.trim="inputVal[item.keyword]"
                    :disabled="!item.editable"
                    v-if="!item.canSelect"
                    :class="{ 'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1 }"
                    :maxlength="item.inputLength || 200">
                    <el-select v-model="inputVal[item.keyword + '_http']" slot="prepend" v-if="$config.form.httpFields.indexOf(item.keyword) > -1">
                        <el-option v-for="item in $t('select.httpOptions')" :key="item.label" :value="item.value"></el-option>
                    </el-select>
                    <template slot="prepend" v-if="$config.form.phoneCodeFields.indexOf(item.keyword) > -1 && inputVal.cCode">{{inputVal.cCode}}</template>
                    <template slot="prepend" v-if="$config.form.phoneCodeFieldsQH.indexOf(item.keyword) > -1 && inputVal.HQCode">{{inputVal.HQCode}}</template>
                    </el-input>
                </template>
                <!-- 总部国家 -->
                <el-select
                    :placeholder="getLabelName(item, 'placeholder')"
                    v-model="inputVal.countryHeadQuaterId" 
                    :disabled="!item.editable" 
                    v-if="item.keyword == 'countryHeadQuaterId'" 
                    @change="changeCountryQH" filterable>
                  <el-option v-for="c in gOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                </el-select>
                <!-- 公司所在国 -->
                <el-select
                    :placeholder="getLabelName(item, 'placeholder')"
                    v-model="inputVal.corporateCountryId" 
                    :disabled="!item.editable" 
                    v-if="item.keyword == 'corporateCountryId'" 
                    @change="changeCountry2" filterable>
                  <el-option v-for="c in gOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                </el-select> 
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <!-- 海外总部公司信息 -->
        <div class="reg-title" v-if="fieldsLength[2] > 0">{{ $t('login2s.overseasCompanyInfo') }}</div>
        <el-row :gutter="30">
          <template v-for="item in configInputList">
            <el-col :span="24" :key="item.id" v-if="overseasCompanyFieldsList.indexOf(item.keyword) > -1">
              <template v-if="uploadFields.indexOf(item.keyword) > -1">
                <!-- 登记证 -->
                <el-form-item class="v-img-border" label-width="0" :prop="item.keyword" v-if="item.keyword == 'registration'">
                  <div class="flex-start headerImg m-b-24">
                    <h4>
                      <template v-if="item.required">
                        <span class="v-xing">* </span>
                      </template>{{ getLabelName(item) }}
                    </h4>
                    <div>
                      <p>{{$t('registrationTips')}}</p>
                    </div>
                  </div>
                  <div class="v-header div v-headerImg v-register-flex" style="align-items:flex-start">
                    <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                      <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingRegistration" :class="{ 'v-uploader-disabled': !item.editable }">
                        <el-upload
                          class="v-uploader"
                          action=""
                          :disabled="!item.editable"
                          :show-file-list="false"
                          :http-request="loadRegistrationImg"
                          :accept="uploadType">
                          <img v-if="inputVal.registration" :src="inputVal.registration" alt="" class="v-header-img" />
                          <i v-else class="iconfont iconshangchuan"></i>
                        </el-upload>
                      </div>
                      <div class="font-size-14 text-right">
                        <div class="flex-end align-center v-btn-box" v-if="item.editable">
                          <div class="flex-start align-center v-btn-box" v-if="item.editable">
                            <!-- <el-upload action="" :http-request="loadRegistrationImg" :show-file-list="false" :accept="uploadType">
                              <span class="theme-color padding-r-12">
                                {{inputVal.registration ? $t('Upload again') : $t('Upload picture')}}</span>
                            </el-upload> -->
                            <span
                              class="theme-color pointer"
                              @click="inputVal.registration = ''"
                              v-if="inputVal.registration">{{ $t('del') }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="v-up-tip v-head-up-tip tipsColor margin-tb-12"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                    </div>
                    <div class="v-workPass-l" style="height: 191px">
                      <template v-if="language == 'zh'">
                        <img :src="registrationCn"/>
                      </template>
                      <template v-else>
                        <img :src="registrationCn"/>
                      </template>
                    </div>
                  </div>
                  <el-input v-model="inputVal.registration" v-show="false"></el-input>
                </el-form-item>
                <!-- 证件照 -->
                <!-- 个人工作证 -->
                <el-form-item class="v-img-border" label-width="0" :prop="item.keyword"  v-if="item.keyword == 'workPass' || item.keyword == 'idImage'">
                  <div class="flex-start headerImg m-b-24">
                    <h4>
                      <template v-if="item.required">
                        <span class="v-xing">* </span>
                      </template>{{ item.name }}
                    </h4>
                    <div>
                      <p>{{$t('workPassTips')}}</p>
                    </div>
                  </div>
                  <div class="v-header div v-headerImg v-register-flex" style="align-items:flex-start">
                    <div class="v-load-img-box align-center padding-left-104 v-workPass-r" style="margin-top: 0; margin-bottom: 0;">
                      <div class="relativeWorkPass v-header-relative" v-loading="imgLoadingWorkPass" :class="{ 'v-uploader-disabled': !item.editable }">
                        <el-upload
                          class="v-uploader"
                          action=""
                          :disabled="!item.editable"
                          :show-file-list="false"
                          :http-request="loadWorkPassImg"
                          :accept="uploadType">
                          <img v-if="inputVal[item.keyword]" :src="inputVal[item.keyword]" alt="" class="v-header-img" />
                          <i v-else class="iconfont iconshangchuan"></i>
                        </el-upload>
                      </div>
                      <div class="font-size-14 text-right">
                        <div class="flex-end align-center v-btn-box" v-if="item.editable">
                          <div class="flex-start align-center v-btn-box" v-if="item.editable">
                            <!-- <el-upload action="" :http-request="loadWorkPassImg" :show-file-list="false" :accept="uploadType">
                              <span class="theme-color padding-r-12">
                                  {{inputVal[item.keyword] ? $t('Upload again') : $t('Upload picture')}}</span>
                            </el-upload> -->
                            <span
                              class="theme-color pointer"
                              @click="inputVal[item.keyword] = ''"
                              v-if="inputVal[item.keyword]">{{ $t('del') }}</span>
                          </div>
                        </div>
                      </div>
                      <span class="v-up-tip v-head-up-tip tipsColor margin-tb-12"><i class="el-icon-warning"></i>{{ $t('Only support png & jpg, less than 1Mb') }}</span>
                    </div>

                    <div class="v-workPass-l" style="height: 191px">
                      <template v-if="language == 'zh'">
                        <img :src="workPassCn"/>
                      </template>
                      <template v-else>
                        <img :src="workPassCn"/>
                      </template>
                    </div>
                  </div>
                  <el-input v-model="inputVal[item.keyword]" v-show="false"></el-input>
                </el-form-item>
              </template>
              <el-form-item v-else :label="getLabelName(item)" :prop="item.keyword">
                <template v-if="$config.form.allowSpaceFields.indexOf(item.keyword) > -1">
                    <el-input
                        :placeholder="getLabelName(item, 'placeholder')"
                        v-model="inputVal[item.keyword]"
                        :disabled="!item.editable"
                        v-if="!item.canSelect"
                        :class="{ 'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1 }"
                        :maxlength="item.inputLength || 200">
                    </el-input>
                </template>
                <template v-else>
                    <el-input
                        :placeholder="getLabelName(item, 'placeholder')"
                        v-model.trim="inputVal[item.keyword]"
                        :class="{ 'input-with-select': $config.form.httpFields.indexOf(item.keyword) > -1 }"
                        :disabled="!item.editable"
                        v-if="!item.canSelect"
                        :maxlength="item.inputLength || 200">
                        <el-select v-model="inputVal[item.keyword + '_http']" slot="prepend" v-if="$config.form.httpFields.indexOf(item.keyword) > -1">
                            <el-option v-for="item in $t('select.httpOptions')" :key="item.label" :value="item.value"></el-option>
                        </el-select>
                        <template slot="prepend" v-if="$config.form.phoneCodeFieldsQH.indexOf(item.keyword) > -1 && inputVal.HQCode">{{inputVal.HQCode}}</template>
                    </el-input>
                    <template v-else>
                        <!-- 总部国家 -->
                        <el-select :placeholder="getLabelName(item, 'placeholder')" v-model="inputVal.countryHeadQuaterId" :disabled="!item.editable" v-if="item.keyword == 'countryHeadQuaterId'" @change="changeCountryQH" filterable>
                            <el-option v-for="c in gOption" :key="c.id" :value="parseInt(c.id)" :label="language == 'en' ? c.enName : c.name"></el-option>
                        </el-select>
                    </template>
                </template>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <div class="text-center" v-if="init">
          <el-button type="primary" :loading="loading" class="v-btn no-radius" @click="submit('emailInfo')">{{ $t('Next') }}</el-button>
        </div>
      </el-form>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import headerImgCn from '@/assets/images/headerImg2.png'
import workPassCn from '@/assets/images/workPass2.png'
import registrationCn from '@/assets/images/registration2.png'
import headerImgEn from '@/assets/images/headerImg.png'
import workPassEn from '@/assets/images/workPass.png'
import registrationEn from '@/assets/images/registration.png'
import registerMixin from '@/mixins/register.js'
import formCn from './forms_cn'
import formEn from './forms_en'

import { getFetchList } from '@/api/index'
import { teamAdd, teamUpdate, teamDetail} from '@/api/groupPreRegistration'

export default {
  mixins: [registerMixin],
  computed: {
    ...mapGetters(['language', 'subjectType', 'info', 'config', 'loginAccount', 'loginType'])
  },
  props: ['id'],
  data() {
    return {
      isFace:false,
      headerImgCn: headerImgCn,
      workPassCn: workPassCn,
      registrationCn: registrationCn,
      headerImgEn: headerImgEn,
      workPassEn: workPassEn,
      registrationEn: registrationEn,
      imgLoading: false,
      imgLoadingWorkPass: false,
      imgLoadingRegistration: false,
      loading: false,
      fieldsList: ['countryName', 'provinceName', 'cityName'],
      uploadFields: ['headImage', 'registration', 'workPass', 'idImage'],
      personFieldsList: [
        'name',
        'countryId', 'provinceId', 'cityId', 'idType','idImage','post',
        'email','mobile',
        'socialMedia','headImage','workPass'
      ],
      companyFieldsList: [
        'corporateName','corporateCountryId','brand','website','address',
        'telephone','fax','registration'
      ],
      overseasCompanyFieldsList : [
        'nameHeadQuater','countryHeadQuaterId','addressHeadQuater','telephoneHeadQuater',
        'faxHeadQuater','emailHeadQuater','websiteHeadQuater'
      ],
      type: this.$route.params.type, //0 账号信息，1 完善信息
      inputVal: {
        faxCode: '',  //国家码
        faxCode1: '', //城市码
        cCode: '',    //公司所在国家码
        HQCode:''     //总部国家码
      },
      sexOption: [
        {
          label: this.$t('sex[0]'),
          value: this.$t('sex[0]')
        },
        {
          label: this.$t('sex[1]'),
          value: this.$t('sex[1]')
        }
      ],
      // 社交媒体字典
      socialMediaOption: this.$t('select.socialMediaOptions'),
      // 证件类型字典
      idTypeOption: localStorage.getItem('language') == 'en' ? this.$t('select.idTypeOptionsEN') : this.$t('select.idTypeOptions'),
      //国家
      gOption: [],
      //省
      pOption: [],
      //市
      cOption: [],
      rules: {},
      configSwitch: {}, //配置开关
      configInputList: [],
      fieldsLength: [0, 0, 0],
      init: false,
      maxImgSize: 2 * 1024 * 1024,
      uploadType: 'image/png, image/jpeg',
      // 是否带入公司信息
      checked: false
    }
  },
  watch: {
    'checked': {
        handler() {
            if (this.checked) {
                this.getPerson(this.companyFieldsList, this.info.visitor)
            }
        },
        immediate: true
    }
  },
  components: {},
  created() {
    this.pageInit()
  },
  methods: {
    // 根据国家 更换字段
    changeCountryCallback(value) {
        this.changeCountry(value)
        this.loadConfig(value == 86 ? true : false)
    },
    // 获取字段文本
    getLabelName(data, name = 'name') {
        if (name === 'name') {
            return this.language === 'en' ? data.nameEn : data.name
        } else if (name === 'address') {
            return this.language === 'en' ? data.enName : data.name
        } else {
            return this.language === 'en' ? data.placeholderEn : data.placeholder
        }
    },
    // 页面初始化
    pageInit() {
        // inputVal 值初始化
        let list = [...this.personFieldsList, ...this.companyFieldsList]
        if (this.language === 'zh') {
            list = [...list, ...this.overseasCompanyFieldsList]
        }
        list.forEach((key) => {
            this.$set(this.inputVal, key, undefined)

            if (this.$config.form.httpFields.indexOf(key) > -1) {
                this.$set(this.inputVal, key + '_http', 'http://')
            }
        })
        if (this.id) {
            this.getUserInfo(list)
        } else {
            this.formInput()
        }
    },
    // 表单字段初始化
    formInput() {
        let language = this.language
        if (this.inputVal.countryId) {
            if ( this.inputVal.countryId === 86) {
                language = 'zh'
            } else {
                language = 'en'
            }
        }
        this.loadConfig(language === 'en' ? false : true)
        this.getCountry()
    },
    // 表单编辑，通过id获取用户表单值
    getUserInfo(list) {
        this.loading = true
        teamDetail({
            id: this.id
        }).then(res => {
            return res.data
        }).then(res => {
            this.getPerson(list, res.data || {})
        }).finally(() => {
            this.loading = false
            this.formInput()
        })
    },
    // 给form表单赋值（公司信息）
    getPerson(list, info) {
        list.forEach((key) => {
            let value = info[key]
            if (!value) return true
            this.$set(this.inputVal, key, value)

            if (key === 'corporateCountryId') {
                // 公司所在国
                this.changeCountry2(value)
            } else if (key === 'countryHeadQuaterId') {
                // 总部所在国
                this.changeCountryQH(value)
            } else if (key === 'countryId') {
                // 国家
                this.changeCountry(value, true)
            }

            // 网址
            if (this.$config.form.httpFields.indexOf(key) > -1) {
                let info = value
                let httpValue = ''
                if (info && info.indexOf('http://') == 0) {
                    httpValue = info.substr(7)
                    this.$set(this.inputVal, key + '_http', 'http://')
                } else if (info && info.indexOf('https://') == 0) {
                    httpValue = info.substr(8)
                    this.$set(this.inputVal, key + '_http', 'https://')
                }
                this.$set(this.inputVal, key, httpValue)
            }

            // 电话，传参拆分
            switch(key) {
                case 'telephoneHeadQuater':
                case 'telephone':
                case 'fax':
                case 'faxHeadQuater':    
                    if (value.indexOf('-') !== -1) {
                        let strA = value.split('-')
                        this.$set(this.inputVal, key, strA[strA.length-1])
                    }
                    break
            }
        })
    },
    // 获取form字段
    loadConfig(status) {
      this.loading = true
      getFetchList()
        .then(res => {
          return res.data
        })
        .then(res => {
            if(!res.data) return
            /**
             * 生成验证规则
             */
            let list = status === true ? JSON.parse(JSON.stringify(formCn.fields)) : JSON.parse(JSON.stringify(formEn.fields));
            this.itemConifg = {}
            this.rules = {}
            list.forEach((item) => {

                switch (item.keyword) {
                    case 'provinceName':
                        item.keyword='provinceId'
                        break
                    case 'countryName':
                        item.keyword='countryId'
                        break
                    case 'cityName':
                        item.keyword='cityId'
                        break
                    case 'corporateCountryName':
                        item.keyword='corporateCountryId'
                        break
                    case 'countryHeadQuater':
                        item.keyword='countryHeadQuaterId'
                        break
                }

                if (item.keyword == 'mobile') {
                    item.inputLength = 11
                    if (this.inputVal[item.keyword]) {
                        item.editable = false
                    }
                }

                if (item.keyword === 'email') {
                    if (this.inputVal[item.keyword]) {
                        item.editable = false
                    }
                }

                // 必填条件
                if (item.required) {
                    let field = this.changeField(item.keyword) || item.keyword
                    
                    if (!this.rules[field]) {
                        this.$set(this.rules, field, [])
                    }

                    if (field === 'email' || field === 'emailHeadQuater') {
                        this.rules[field].push({
                            type: 'email',
                            required: true,
                            message: (this.language === 'en' ? item.nameEn : item.name) + ' ' + this.$t('a olute or self-relative'),
                            trigger: 'change'
                        })
                    } else {
                        this.rules[field].push({
                            required: true,
                            message: (this.language === 'en' ? item.nameEn : item.name) + ' ' + this.$t('common.required'),
                            trigger: 'change'
                        })
                    }
                }

                this.itemConifg[item.keyword] = item
            })

            this.configInputList = {...list}
            this.fieldsLength = [0, 0, 0]
            for(let k in this.configInputList) {
                let data = this.configInputList[k]
                if (this.personFieldsList.indexOf(data.keyword) > -1) {
                    this.fieldsLength[0] ++ 
                } else if (this.companyFieldsList.indexOf(data.keyword) > -1) {
                    this.fieldsLength[1] ++ 
                } else if (this.overseasCompanyFieldsList.indexOf(data.keyword) > -1) {
                    this.fieldsLength[2] ++ 
                }
            }
            this.configSwitch = res.data.configSwitch
            this.isFace = this.configSwitch.face
            this.$nextTick(() => {
                this.$refs['emailInfo'].clearValidate()
            })
        })
        .finally(() => {
          this.loading = false
          this.init = true
        })
    },
    // 提交
    submit(name) {

      this.$refs[name].validate(valid => {
        if (valid) {
          this.loading = true
          if (this.isFace) {
            this.inputVal.facePhotoUrl = this.inputVal.headImage
          }
          let params = JSON.parse(JSON.stringify(this.inputVal))
          params.countryCode = params.faxCode

          for (let key in params) {
            //公司电话/传真
            if (this.$config.form.phoneCodeFields.indexOf(key) > -1 && params.cCode && params[key] && key !== 'mobile') {
              params[key] = params.cCode + '-' + params[key]
            }

            //总部国家电话/传真
            if (this.$config.form.phoneCodeFieldsQH.indexOf(key) > -1 && params.HQCode && params[key]) {
              params[key] = params.HQCode + '-' + params[key]
            }

            // 网址
            if (this.$config.form.httpFields.indexOf(key) > -1 && params[key]) {
              params[key] = params[key + '_http'] + params[key]
            }
          }
          
          delete params.faxCode
          delete params.faxCode1
          delete params.cCode
          delete params.HQCode
          delete params.website_http
          delete params.websiteHeadQuater_http
          delete params.countryName
          delete params.provinceName
          delete params.cityName
          //delete params.provinceId
          //delete params.cityId
          delete params.corporateCountryName
          delete params.countryHeadQuater

          if (this.id) {
            params.id = this.id
            teamUpdate(params).then(() => {
                this.$router.go(-1)
            }).finally(() => {
                this.loading = false
            })
          } else {
            teamAdd(params).then(() => {
                this.$router.go(-1)
            }).finally(() => {
                this.loading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="stylus">
    @import '~@/styles/pages/register'
</style>
<style lang="stylus" scoped>
.bl-register-box {
    top: 0;
    margin: 30px auto;
    width: 100%;
    background: $color-gray-fb;
    box-shadow: none;
}

.v-from-wrap {
    margin: 0 auto;
    width: 730px;

    .v-headerImg {
        background: $color-gray-f5;
    }
} 

</style>
